module.exports = __webpack_public_path__ + "img/bg2.4db5d2c2.jpg";